import store from '../../store';

export default async (to, from, next) => {

    if (process.env.VUE_ENV === 'development'){
        console.log(to.name.split('-')[1]);
        console.log(store.getters['roles']);
        console.log(store.getters['permissions']);
    }


    let permissions = await store.getters['permissions'];
    let auth = await store.getters['authenticated'];
    if(auth){
        if (permissions.includes('read ' + to.name.split('-')[1]) && permissions.includes('viewAny ' + to.name.split('-')[1])){
            next();
        } else {
            await store.dispatch('setErrorModal', true);
            await store.dispatch('setErrorMessage', `You don\'t have permission to view ${to.name.split('-')[1]}`);
            next({path: from.path});
        }
    }else{
        next({name: 'login-page'});
    }

}